import type { ComponentByScreen } from '@/types/screens';
import { DrawerScreen } from '@/types/screens';
import { PaymentMethodList } from '@/components/PaymentMethodList/PaymentMethodList';
import { SavedCardList } from '@/components/SavedCardList/SavedCardList';
import { AddNewCardForm } from '@/components/AddNewCardForm/AddNewCardForm';

export const COMPONENT_BY_SCREEN: ComponentByScreen = {
  [DrawerScreen.OTHER_PAYMENT_METHOD]: PaymentMethodList,
  [DrawerScreen.SAVED_CARDS]: SavedCardList,
  [DrawerScreen.NEW_CARD]: AddNewCardForm,
};
